import { Component, OnInit } from '@angular/core';
import { LoginComponent } from "../auth/login/login.component";
import { AuthService } from '../auth/auth.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit {
  public loggedIn: boolean

  constructor(private authService: AuthService, private router: Router, private route: ActivatedRoute) {

  }

  ngOnInit() {
    this.loggedIn = this.authService.isLoggedIn;

    if (!this.authService.isLoggedIn) {
      this.router.navigate(['login']);
    }
  }
}
